import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import "./Matching.css"; // For custom CSS

function Matching({
  instructions,
  leftColumn,
  rightColumn,
  correctMatches,
  index,
}) {
  const [userMatches, setUserMatches] = useState({});
  const [feedback, setFeedback] = useState("");

  const handleMatch = (leftItem, rightItem) => {
    setUserMatches({ ...userMatches, [leftItem]: rightItem });
  };

  const handleSubmit = () => {
    let isCorrect = true;
    for (let index in correctMatches) {
      if (correctMatches[index] !== userMatches[index]) {
        isCorrect = false;
        break;
      }
    }
    setFeedback(
      isCorrect
        ? "All matches are correct!"
        : "Some matches are incorrect. Try again!"
    );
  };

  return (
    <Card className="matching-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>{index}. Matching Question</Card.Title>
        <Card.Text>{instructions}</Card.Text>
        <div className="matching-container">
          <div className="left-column">
            {leftColumn.map((item) => (
              <div key={item} className="left-item">
                {item}
                <select
                  style={{
                    backgroundColor: "#a24dd386",
                    borderColor: "black",
                    MarginColor: "rgba(81, 5, 100, 0.459)",
                  }}
                  onChange={(e) => handleMatch(item, e.target.value)}
                  value={userMatches[item] || ""}
                >
                  <option value="">Select Category</option>
                  {rightColumn.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        </div>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{ marginTop: "10px" }}
        >
          Submit
        </Button>
        {feedback && (
          <div
            style={{
              marginTop: "10px",
              color: feedback.includes("correct") ? "green" : "red",
            }}
          >
            {feedback}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default Matching;
